import { request } from '../network_new';

const gameServices = {
  // 首页游戏平台数据
  getHomeGamesData(data?: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 381119,
        paramType: 1,
        apiName: 'getHomeGamesData',
      },
    });
  },
  getGamesBigTypeData(data?: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 724300,
        apiName: 'getGamesBigTypeData',
      },
    });
  },
  // 获取彩票数据
  getLotteryData(data?: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 320542,
        apiName: 'getLotteryData',
      },
    });
  },
  // 首页游戏热门平台数据
  getHomeHotGamesData(data?: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 321552,
        paramType: 0,
        apiName: 'getHomeHotGamesData',
      },
    });
  },
};

export default gameServices;
